$(document).ready(function () {

  $('body').on('click', '.pricing_list_item .wp-block-button__link', function (e){
      e.preventDefault();

      let thisPricingItem = $(this).closest('.pricing_list_item');

      let styleTier = thisPricingItem.find('.pricing_list_item__top-tier').attr('style');
      let textTier = thisPricingItem.find('.pricing_list_item__top-tier').text();
      let title = thisPricingItem.find('.pricing_list_item__title').text();
      let price = thisPricingItem.find('.pricing_list_item__price').text();
      let list = thisPricingItem.find('.wp-block-list').html();

      $('#subscribe_to_linklogiq .modal__content-info-top span:last-child').text(textTier).attr('style', styleTier);
      $('#subscribe_to_linklogiq .modal__content-info-top span:first-child').text(title + ' - ' + price);
      $('#subscribe_to_linklogiq .modal__content-info-list .wp-block-list').html(list);
      $('#subscribe_to_linklogiq #hidden-field').val(price);

      $('#subscribe_to_linklogiq').addClass('open').fadeIn(500);
  });

});